import Component from './Component';

export default class AnimationComponent extends Component {
    public playOnStart: boolean = undefined;
    public clipName: string = undefined;
    public isPlaying: boolean = false;
    public timeScaleContext: 'local' | 'global' = 'global';
    public timeScale: number = 1;
    public meta?: any = undefined;
}
